export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'Home',
      SAMPLE: 'Sample',
      BITSO: 'Bitso',
      PRONOSTICO: 'Pronostico'
    }
  }
}
